<template>
  <div class="input-hint">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'InputHint',
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";

.input-hint {
  margin-top: 5px;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  color: $active-green;
}
</style>
